export default "__VITE_ASSET__Dv$$aKSz__"